exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".li-selected-img{\n    /*width: 320px;*/\n    min-height: 320px;\n    height: 320px;\n}\n\n\n.li-img {\n    width: 100% !important;\n    height: 100% !important;\n}\n.product-description{\n    padding:10px 22px 0px 20px\n}\n.product-detail-box {\n  position: absolute;\n  bottom: 12px;\n  left: 46px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/oneills-web-qa/src/app/product/product.component.css
// module id = ../../../../../src/app/product/product.component.css
// module chunks = main